import './bootstrap';
import '../css/app.css';
import Alpine from 'alpinejs';
import 'animate.css';
import './animated-text';
import '@hotwired/turbo';
// import './glowing-circles';
// import './flashing-lines';
window.Alpine = Alpine

Alpine.start();

preserveWindowPosition();
smoothScrollingToPosition();
var xPoint = document.getElementById('x');
var yPoint = document.getElementById('y');
var zPoint = document.getElementById('z');
var line = document.querySelector('.line');
var line2 = document.querySelector('.line2');
var ready = true;

function preserveWindowPosition() {
    document.addEventListener("DOMContentLoaded", function (event) {
        var scrollpos = sessionStorage.getItem("scrollpos");
        if (scrollpos) window.scrollTo(0, scrollpos);
        sessionStorage.removeItem('scrollpos');
    });

    window.onscroll = function (e) {
        sessionStorage.setItem("scrollpos", window.scrollY);
    };
}

function smoothScrollingToPosition() {
    document.querySelectorAll('.contact-us-button').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
            e.preventDefault();
            document.querySelector(this.getAttribute('href')).scrollIntoView({
                behavior: "smooth"
            });
        });
    });
}

function calculateDistance(point2, point1) {
    var distX = point2.offsetLeft - point1.offsetLeft;
    var distY = point2.offsetTop - point1.offsetTop;

    return Math.sqrt((distX * distX) + (distY * distY));
}

function triggerLineRendering(point2, point1){
    var distance = calculateDistance(point2, point1);
    //myMove(distance);
    var elem = document.getElementById('Line_3');
    elem.setAttribute( "y2", distance - 50);
}

function isInViewport (elem) {
    var bounding = elem.getBoundingClientRect();
    return (
        bounding.top >= 0 &&
        bounding.left >= 0 &&
        bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

window.setupAutomatedReportingPage = function() {


    console.log("setupAutomatedReportingPage called");

    const svg = document.getElementById('triangle-svg');
    const circleGroups = document.querySelectorAll('.circle-panel-group');
    const amplitude = 25.5;
    const speed = 0.0002;
    let animationActive = true;

    if (window.innerWidth <= 480) {
        circleGroups.forEach(group => {
            let baseX, baseY;
            switch (group.dataset.panel) {
                case 'panel1':
                    baseX = 340; baseY = 100;
                    break;
                case 'panel2':
                    baseX = 120; baseY = 410;
                    break;
                case 'panel3':
                    baseX = 460; baseY = 510;
                    break;
                default:
                    baseX = 0; baseY = 0;
            }
            group.style.transform = `translate(${baseX}px, ${baseY}px)`;
            group.dataset.baseTransform = `translate(${baseX}px, ${baseY}px)`;
        });
    } else {
        circleGroups.forEach(group => {
            group.dataset.baseTransform = group.getAttribute('transform');
        });
    }

    const updateLines = () => {
        const positions = Array.from(circleGroups).map(group => {
            const circle = group.querySelector('circle');
            const bbox = circle.getBBox();
            const cx = bbox.x + bbox.width / 2;
            const cy = bbox.y + bbox.height / 2;
            let point = { x: cx, y: cy };

            if (window.innerWidth <= 480) {
                const computedStyle = window.getComputedStyle(group);
                const transform = computedStyle.transform;
                if (transform && transform !== 'none') {
                    const matrixMatch = transform.match(/matrix\(([^)]+)\)/);
                    if (matrixMatch) {
                        const values = matrixMatch[1].split(',').map(val => parseFloat(val.trim()));
                        const tx = values[4] || 0;
                        const ty = values[5] || 0;
                        point.x += tx;
                        point.y += ty;
                    }
                }
            } else {
                const svgPoint = svg.createSVGPoint();
                svgPoint.x = cx;
                svgPoint.y = cy;
                const transformedPoint = svgPoint.matrixTransform(group.getCTM());
                point = { x: transformedPoint.x, y: transformedPoint.y };
            }

            return point;
        });

        ['line1', 'line2', 'line3'].forEach((lineId, idx) => {
            const line = document.getElementById(lineId);
            const p1 = positions[idx];
            const p2 = positions[(idx + 1) % positions.length];
            line.setAttribute('x1', p1.x);
            line.setAttribute('y1', p1.y);
            line.setAttribute('x2', p2.x);
            line.setAttribute('y2', p2.y);
        });
    };

    // Animate the groups
    const animateCircles = () => {
        const startTime = performance.now();

        const animate = (time) => {
            if (animationActive) {
                const elapsed = time - startTime;
                circleGroups.forEach((group, idx) => {
                    const stopOnHover = group.dataset.stopOnHover === 'true';
                    if (!(group.matches(':hover') && stopOnHover)) {
                        const xOffset = Math.sin(elapsed * speed + idx) * amplitude;
                        const yOffset = Math.cos(elapsed * speed + idx) * amplitude;

                        const baseTransform = group.dataset.baseTransform;
                        const match = baseTransform.match(/translate\(([^,]+),\s*([^)]+)\)/);
                        let baseX = 0, baseY = 0;
                        if (match) {
                            baseX = parseFloat(match[1]);
                            baseY = parseFloat(match[2]);
                        }
                        group.style.transform = `translate(${baseX + xOffset}px, ${baseY + yOffset}px)`;
                    }
                });
                updateLines();
            }
            requestAnimationFrame(animate);
        };
        requestAnimationFrame(animate);
    };

    circleGroups.forEach(group => {
        const panelId = group.dataset.panel;
        const panel = document.getElementById(panelId);
        const stopOnHover = group.dataset.stopOnHover === 'true';

        // Desktop hover events
        group.addEventListener('mouseenter', () => {
            panel.classList.add('expanded');
            if (stopOnHover) {
                animationActive = false;
            }
        });

        group.addEventListener('click', () => {
            panel.classList.add('expanded');
            if (stopOnHover) {
                animationActive = false;
            }
        });

        group.addEventListener('mouseleave', () => {
            panel.classList.remove('expanded');
            animationActive = true;
        });


        if ('ontouchstart' in window) {
            group.addEventListener('click', () => {
                panel.classList.add('expanded');

                // Toggle the panel's expanded state on click
                if (panel.classList.contains('expanded')) {
                    panel.classList.remove('expanded');
                    animationActive = true;
                } else {
                    panel.classList.add('expanded');
                    if (stopOnHover) {
                        animationActive = false;
                    }
                }
            });
        }
    });

    animateCircles();
    if (window.innerWidth <= 1480) {
        circleGroups.forEach(group => {
            let baseX, baseY;
            switch (group.dataset.panel) {
                case 'panel1':
                    baseX = 440; baseY = 200;
                    break;
                case 'panel2':
                    baseX = 150; baseY = 410;
                    break;
                case 'panel3':
                    baseX = 460; baseY = 510;
                    break;
                default:
                    baseX = 0; baseY = 0;
            }
            group.style.transform = `translate(${baseX}px, ${baseY}px)`;
            group.dataset.baseTransform = `translate(${baseX}px, ${baseY}px)`;
        });
    } else {
        circleGroups.forEach(group => {
            group.dataset.baseTransform = group.getAttribute('transform');
        });
    }

    let dragging = null;
    let dragOffset = { x: 0, y: 0 };

    circleGroups.forEach(group => {

        group.addEventListener('pointerdown', (e) => {
            animationActive = false;
            dragging = group;

            const computedStyle = window.getComputedStyle(group);
            const transform = computedStyle.transform || 'matrix(1, 0, 0, 1, 0, 0)';
            const match = transform.match(/matrix\(([^,]+),\s*([^,]+),\s*([^,]+),\s*([^,]+),\s*([^,]+),\s*([^)]+)\)/);
            let x = 0, y = 0;
            if (match) {
                x = parseFloat(match[5]);
                y = parseFloat(match[6]);
            }

            dragOffset.x = e.clientX - x;
            dragOffset.y = e.clientY - y;

            group.setPointerCapture(e.pointerId);

            e.preventDefault();
        });

    });

    window.addEventListener('pointerup', (e) => {
        if (dragging) {
            dragging.dataset.baseTransform = dragging.style.transform;
            dragging.releasePointerCapture(e.pointerId);
            dragging = null;
            animationActive = true;
            e.preventDefault();
        }
    });

    window.addEventListener('pointermove', (e) => {
        if (dragging) {
            const footer = document.getElementById('contact-us');
            const footerRect = footer.getBoundingClientRect();
            const footerTopAbsolute = footerRect.top + window.scrollY - 120;
            const circleRect = dragging.getBoundingClientRect();

            let x = e.clientX - dragOffset.x;
            let y = e.clientY - dragOffset.y;

            // Calculate new potential circle position
            let newCircleBottom = y + circleRect.height;


            // If circle tries to move below footer top, adjust position
            if (newCircleBottom > footerTopAbsolute) {
                y = footerTopAbsolute - circleRect.height - 5;
            }

            // If circle tries to move above the top of the viewport, adjust position
            if (newCircleBottom < -30) {
                y = -25; // 5px buffer for a nice spacing
            }

            dragging.style.transform = `translate(${x}px, ${y}px)`;
            updateLines();
        }
    });

}
